import { memo, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import HistorianPeopleTable from './historian-people-table';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { useFormikContext } from 'formik';
import { HttpResponseList } from 'shell/models/http-response';
import { HistoryCohabitationVM } from 'cohabitation/view-models/history-cohabitation';
import { DateTime } from 'luxon';

export interface PersonVM {
  familyNumber: string;
  surnameName: string;
  birthday: string;
  birthplace: string;
  regDate: string;
  reason: string;
}

const AccordionHistorianPeoleComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formikContext = useFormikContext<HistoryCohabitationVM>();

  const familyId = parseInt(formikContext.values.cohabitationData?.idSipo || '', 10);

  const [people] = useHttpFetch<
    HttpResponseList<{
      codiceFamiglia: number;
      cognome: string;
      cognomeNome: string;
      comuneDiNascita: string;
      dataNascita: string;
      dataRegistrazione: string;
      key: { ente: string; codice: number };
      motivo: string;
      nome: string;
      sesso: string;
    }>,
    Array<PersonVM>
  >(`${__PERSON_API_URL__}/persona/sipo/dettaglio/residenti-convivenza/${familyId}`, {
    onBootstrap: true,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: (response) => {
      const relations = response.data?.payload?.list || [];

      return relations.map((relation) => ({
        familyNumber: relation.codiceFamiglia?.toString() || '',
        surnameName: relation.cognomeNome || '',
        birthday: relation.dataNascita
          ? DateTime.fromISO(relation.dataNascita).toFormat('dd/MM/yyyy')
          : '',
        birthplace: relation.comuneDiNascita || '',
        regDate: relation.dataRegistrazione
          ? DateTime.fromISO(relation.dataRegistrazione).toFormat('dd/MM/yyyy')
          : '',
        reason: relation.motivo || '',
      }));
    },
  });

  return (
    <Accordion expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary
        aria-controls="panel-historina-people-content"
        id="panel-historina-people-content"
        expandIcon={<ExpandMore />}
      >
        <Typography>Storico persone in convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <HistorianPeopleTable people={people.data as Array<PersonVM>} />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionHistorianPeoleComponent.displayName = 'Change control data accordion component';

const AccordionHistorianPeole = memo(AccordionHistorianPeoleComponent);

export default AccordionHistorianPeole;
